/**
 * patientDocsHelpers
 * -------------------
 * Helpers puros para `PatientDocsCard`. Extraídos en Phase QR2 para bajar
 * complejidad y permitir tests aislados sin React.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/** Trunca un nombre al máximo de caracteres especificado. */
export function truncate(name, max = 18) {
  if (!name) return '';
  return name.length > max ? `${name.slice(0, max)}…` : name;
}

/** Construye el payload para abrir un consentimiento en `PdfPreviewDialog`. */
export function consentPreviewArgs({ consentId, templateCode, templateName, patientName }) {
  return {
    open: true,
    url: `${BACKEND_URL}/api/consents/${consentId}/pdf`,
    filename: `consent_${templateCode}.pdf`,
    title: `Consent. ${templateName} · ${patientName}`,
  };
}

/** Construye el payload para abrir una receta en `PdfPreviewDialog`. */
export function recipePreviewArgs({ recipeId, medicationName, patientName }) {
  return {
    open: true,
    url: `${BACKEND_URL}/api/recetas/${recipeId}/pdf`,
    filename: `receta_${medicationName}.pdf`,
    title: `Receta · ${medicationName} · ${patientName}`,
  };
}

/** Construye el payload para abrir unas indicaciones postoperatorias en `PdfPreviewDialog`. */
export function postopPreviewArgs({ docId, templateName, patientName }) {
  return {
    open: true,
    url: `${BACKEND_URL}/api/postoperatorios/documents/${docId}/pdf`,
    filename: `postop_${docId}.pdf`,
    title: `Postop. ${templateName || ''} · ${patientName}`.replace(' ·  · ', ' · '),
  };
}

/** Construye la vista previa del bloque de postoperatorio y recetas elegidas. */
export function postopRecipesBundlePreviewArgs({ postopDocId, recipeIds = [], patientName }) {
  const params = new URLSearchParams();
  params.set('postop_doc_id', postopDocId);
  recipeIds.forEach((recipeId) => params.append('recipe_ids', recipeId));
  return {
    open: true,
    url: `${BACKEND_URL}/api/quirofano/print-bundle?${params.toString()}`,
    filename: 'postoperatorio_y_recetas.pdf',
    title: `Postoperatorio y recetas · ${patientName}`,
  };
}

/** Etiqueta a mostrar en el botón de un consentimiento existente. */
export function consentButtonLabel(consent) {
  if (consent.template_code === 'anestesia') return 'Anestesia';
  return truncate(consent.template_name, 18);
}
